import { ReactComponent as Settings } from "../../assets/svg/Settings.svg";
import { ReactComponent as Check } from "../../assets/svg/Check.svg";
import { ReactComponent as WeatherCloud } from "../../assets/svg/WeatherCloud.svg";
import { ReactComponent as SmartRTL } from "../../assets/svg/SmartRTL.svg";
import { ReactComponent as Refresh } from "../../assets/svg/Refresh.svg";
import { Locations } from "./types";
import { CircularProgress } from "@mui/material";

const darkActive = {
  background: "#00FF00",
  text: "#101828",
  border: "#FFFFFF38",
  route: "#00FF00",
};
const lightActive = {
  background: "#008A00",
  text: "white",
  border: "#FFFFFF38",
  route: "#00FF00",
};
const darkMaintenance = {
  background: "#EFF0F6",
  text: "#6E7191",
  border: "#D9DBE9",
  route: "#6E7191",
};
const lightMaintenance = {
  background: "#EFF0F6",
  text: "#6E7191",
  border: "#D9DBE9",
  route: "#6E7191",
};

export const uavStateColour = (
  uavState?: string,
  flightMode?: string,
  stale?: boolean,
  loading?: boolean,
  inEmergency?: boolean,
  dark: boolean = true
): {
  background: string;
  text: string;
  border: string;
  route: string;
} => {
  if (loading) {
    return {
      background: "#000000",
      text: "#FFFFFF",
      border: "#FFFFFF38",
      route: "#000000",
    };
  }
  if (stale) {
    return {
      background: "#EFF0F6",
      text: "#6E7191",
      border: "#D9DBE9",
      route: "#6E7191",
    };
  }
  if (inEmergency) {
    return {
      background: "#ED0505",
      text: "#FFFFFF",
      border: "#FFFFFF38",
      route: "#EE0000",
    };
  }
  if (uavState === "ABORT") {
    return {
      background: "#FAFF00",
      text: "#101828",
      border: "#FFFFFF38",
      route: "#FAFF00",
    };
  }

  if (uavState === "MAINTENANCE") {
    return dark ? darkMaintenance : lightMaintenance;
  }
  if (uavState === "STANDBY") {
    return dark ? darkActive : lightActive;
  }
  if (uavState === "MISSION") {
    return dark ? darkActive : lightActive;
  }
  if (uavState === "MOTORSTEST") {
    return dark ? darkActive : lightActive;
  }
  if (flightMode === "AUTO") {
    return dark ? darkActive : lightActive;
  }
  if (flightMode === "POSHOLD") {
    return dark ? darkActive : lightActive;
  }
  if (flightMode === "LOITER") {
    return dark ? darkActive : lightActive;
  }
  if (flightMode === "GUIDED") {
    return dark ? darkActive : lightActive;
  }

  return {
    background: "#EFF0F6",
    text: "#6E7191",
    border: "#D9DBE9",
    route: "#6E7191",
  };
};

export const uavIconColours = {
  black: require("../../assets/svg/DroneBlackMap.svg"),
  blue: require("../../assets/svg/DroneBlueMap.svg"),
  yellow: require("../../assets/svg/DroneYellowMap.svg"),
  red: require("../../assets/svg/DroneRedMap.svg"),
  green: require("../../assets/svg/DroneRedMap.svg"),
};
export const uavImageColours = {
  black: require("../../assets/svg/UAV_MAINTENANCE.png"),
  blue: require("../../assets/svg/UAV_MAINTENANCE.png"),
  yellow: require("../../assets/svg/UAV_WARNING.png"),
  red: require("../../assets/svg/UAV_CRITICAL.png"),
  green: require("../../assets/svg/UAV_POSITIVE.png"),
};
export const uavOtherImageColours = {
  black: require("../../assets/svg/TRI_MAINTENANCE.png"),
  blue: require("../../assets/svg/TRI_MAINTENANCE.png"),
  yellow: require("../../assets/svg/TRI_WARNING.png"),
  red: require("../../assets/svg/TRI_CRITICAL.png"),
  green: require("../../assets/svg/TRI_MAINTENANCE.png"),
};

const getSize = (size: "small" | "medium" | "large") => {
  if (size === "small") return 24;
  if (size === "medium") return 28;
  if (size === "large") return 48;
  return 24;
};

export const getUavIcon = (uavState: string, flightMode: string, inEmergency?: boolean) => {
  if (inEmergency) {
    return "red";
  }
  if (uavState === "MAINTENANCE") {
    return "black";
  }
  if (uavState === "STANDBY") {
    return "green";
  }
  if (uavState === "ABORT") {
    return "yellow";
  }
  if (uavState === "MISSION") {
    return "green";
  }
  if (uavState === "MOTORSTEST") {
    return "green";
  }
  return "green";
};

export const getUavStateIcon = (
  uavState?: string,
  flightMode?: string,
  connecting?: boolean,
  loading?: boolean,
  inEmergency?: boolean
) => {
  if (loading) return CircularProgress;
  if (connecting) return Refresh;
  if (uavState === "MAINTENANCE") return Settings;
  if (uavState === "STANDBY") return Check;
  if (uavState === "ABORT") return SmartRTL;
  if (flightMode === "AUTO") return WeatherCloud;
  if (flightMode === "GUIDED") return WeatherCloud;
  if (uavState === "MISSION") return Check;
  if (uavState === "MOTORSTEST") {
    return Settings;
  }
  return Settings;
};

export const locationData: {
  [key in Locations]: { latLon: [number, number] };
} = {
  moorock: {
    latLon: [53.3462485, -7.7155647],
  },
  balbriggan: {
    latLon: [53.606475, -6.197206],
  },
  kerry: {
    latLon: [52.252859, -10.023492],
  },
  none: {
    latLon: [53.606475, -6.197206],
  },
};
export const cellData: {
  [key in string]: { latLon: [number, number]; name: string };
} = {
  BELAIR: {
    latLon: [53.3462485, -7.7155647],
    name: "Moorock",
  },
  BALBRIGGAN: {
    latLon: [53.606475, -6.197206],
    name: "Balbriggan",
  },
  KERRY: {
    latLon: [52.252859, -10.023492],
    name: "Kerry",
  },
  none: {
    latLon: [53.606475, -6.197206],
    name: "None",
  },
  BELAIR_OPS_SIM: {
    latLon: [53.3462485, -7.7155647],
    name: "Moorock Ops Sim",
  },
  BLANCHARDSTOWN: {
    latLon: [53.39249585920035, -6.395358932417054],
    name: "Blanchardstown",
  },
  PECAN_SQUARE: {
    latLon: [33.086472882884244, -97.24988034070546],
    name: "Pecan Square",
  },
  PECAN_SQUARE_TEST_SITE: {
    latLon: [33.049016060747256, -97.29231000142107],
    name: "Pecan Square Test Site",
  },
};

export const properCase = (state: string) => {
  return `${state?.slice(0, 1).toUpperCase()}${state?.slice(1).toLowerCase()}`;
};
